import * as React from 'react';
import Modal from '../Modal/Modal'
import {ModalProps} from '../Modal/types'
import withModal from '../Modal/withModal'

type Props = {
    payments?: number
} & ModalProps;

class Afterpay extends React.Component<Props> {
    render() {
        const { toggleModal, isModalOpen, payments } = this.props;
        let bodyHtml = '';
        let modalTemplate = undefined;
        if (window.innerWidth < 768) {
            modalTemplate = document.querySelector('#afterpay-info-mobile');
        } else {
            modalTemplate = document.querySelector('#afterpay-info-desktop');
        }
        if (modalTemplate) {
            bodyHtml = modalTemplate.innerHTML;
        }
        const message = `Or ${payments === undefined ? 4 : Math.round(payments)} interest-free payments with `
        let logo = '';
        const logoElem = document.querySelector('#afterpay-logo-image');
        if (logoElem) {
            logo = logoElem.innerHTML;
        }
        return (
            <>
                <div className={'afterpay'}>
                    <span className={'afterpay__message'}>{message}</span>
                    <img className={'afterpay__logo'} src={logo} alt={'Afterpay'} />
                    <button className={'afterpay__message-button'} onClick={toggleModal}>More Info</button>
                </div>
                <Modal
                    isOpen={isModalOpen}
                    onRequestClose={toggleModal}
                    body={bodyHtml}
                />
            </>
        );
    }
}

export default withModal(Afterpay);
